import React, { useRef } from 'react'

import { useRecoilState } from 'recoil'

import { useIntl } from 'react-intl'

import { Button, Modal, ModalBody, ModalFoot } from 'mailup-web-components'

import { modalBuyCollaborationState } from '../recoil/state/page'
import evalCondition from 'Helpers/evalCondition'

import './ModalBuyCollaboration.scss'
import { notifyParent } from 'Helpers/notifyParent'

const ModalBuyCollaboration = () => {
  const intl = useIntl()

  const [open, setOpen] = useRecoilState(modalBuyCollaborationState)

  const { current: accountCollaborationEnabled } = useRef(
    evalCondition('co:COLLABORATIONS')
  )
  const { current: userCollaborationEnabled } = useRef(
    evalCondition('uo:COLLABORATIONS')
  )
  const { current: isGest } = useRef(evalCondition('uo:GEST'))
  const { current: ecommerceVisilble } = useRef(
    evalCondition(
      'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
    )
  )

  const handleClose = () => {
    setOpen(false)
  }

  const handleClickBuy = () => {
    notifyParent('redirectMainFrame', ['mshop_Redirector.aspx?t=mshopcollab'])
  }

  const handleClickEnable = () => {
    notifyParent('redirectMainFrame', ['form_gest_permessi.aspx'])
  }

  const getLinkMoreInfo = () => {
    let link = 'https://www.mailup.com/collaboration/'

    if (intl.locale === 'it') {
      link = 'https://www.mailup.it/collaboration/'
    } else if (intl.locale === 'es') {
      link = 'https://www.mailup.es/collaboration/'
    }

    return link
  }

  const handleClickInfo = () => {
    window.open(getLinkMoreInfo(), '_blank','noopener,noreferrer')
  }

  return (
    <Modal
      show={open}
      onClose={handleClose}
      showClose
      closeOnOverlayClick
      data-mu-test='buy-collaboration-modal'
      className='c-modal-buy-collaboration'
    >
      <ModalBody>
        <div className='c-modal-buy-collaboration__icon'>
          <img src='https://shop.mailup.com/Content/InApp/images/collaboration.svg' />
        </div>

        {!accountCollaborationEnabled && (
          <>
            <h1 className='c-modal-buy-collaboration__title'>
              {intl.formatMessage({ id: 'Load.ModalBuyCollaboration.Title' })}
            </h1>
            <p className='c-modal-buy-collaboration__subtitle'>
              {intl.formatMessage({ id: 'Load.ModalBuyCollaboration.Descr' })}
            </p>
          </>
        )}
        {accountCollaborationEnabled && isGest && !userCollaborationEnabled && (
          <>
            <h1 className='c-modal-buy-collaboration__title'>
              {intl.formatMessage({
                id: 'Load.ModalBuyCollaboration.TitleGestNoOption'
              })}
            </h1>
            <p className='c-modal-buy-collaboration__subtitle'>
              {intl.formatMessage({
                id: 'Load.ModalBuyCollaboration.DescrGestNoOption'
              })}
            </p>
          </>
        )}
      </ModalBody>
      <ModalFoot>
        <div className='c-modal-buy-collaboration__footer'>
          {ecommerceVisilble && (
            <>
              <Button kind='secondary' onClick={handleClickInfo}>
                {intl.formatMessage({ id: 'Load.MailupCommon.MoreInfo' })}
              </Button>

              {!accountCollaborationEnabled && (
                <Button kind='primary' onClick={handleClickBuy}>
                  {intl.formatMessage({ id: 'Load.ModalBuyCollaboration.Buy' })}
                </Button>
              )}

              {accountCollaborationEnabled &&
                isGest &&
                !userCollaborationEnabled && (
                  <Button kind='primary' onClick={handleClickEnable}>
                    {intl.formatMessage({ id: 'Load.MailupCommon.Enable' })}
                  </Button>
                )}
            </>
          )}

          {!ecommerceVisilble && (
            <>
              {!accountCollaborationEnabled && (
                <p>
                  {intl.formatMessage({ id: 'Load.ModalBuyNPermission.Buy' })}
                </p>
              )}

              {accountCollaborationEnabled &&
                isGest &&
                !userCollaborationEnabled && (
                  <Button kind='primary' onClick={handleClickEnable}>
                    {intl.formatMessage({ id: 'Load.MailupCommon.Enable' })}
                  </Button>
                )}
            </>
          )}
        </div>
      </ModalFoot>
    </Modal>
  )
}

export default ModalBuyCollaboration
